import type * as Common from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends ChakraV3.ErrorProps {
  error: Common.PiccoloError;
}

export const PiccoloError = (props: Props) => {
  const { error, ...rest } = props;

  return <ChakraV3.Error title={error.type} description={error.message} {...rest} />;
};
